/**
 *
 */
acf.addAction("ready", function () {
  workshopLoader();
  sidebarNavigationModifier();
});

acf.addAction("af/form/setup", function (form) {
  stepsActivator(form);
  goToStep(window.location.search, form);
});

/**
 *
 */
function workshopLoader() {
  setTimeout(() => {
    $(".workshop-form").addClass("workshop-form--loaded");
  }, 2000);

  var descriptionFirst = $(
    '.workshop-form-steps-header__content[data-index="0"]'
  );

  if (descriptionFirst) {
    descriptionFirst.addClass("workshop-form-steps-header__content--active");
  }
}

/**
 *
 */
function sidebarNavigationModifier() {
  var headlines = $(".workshop-form-steps-header__content");

  if (headlines) {
    setTimeout(() => {
      Array.from(headlines).forEach((element) => {
        var text = $(element)
          .find(".workshop-form-steps-header__content-headline")
          .text();
        var step = $(element).data("index");
        if ($(".af-page-button[data-index=" + '"' + step + '"]')) {
          if (text) {
            $(".af-page-button[data-index=" + '"' + step + '"]')
              .find(".title")
              .text(text);
          }
        }
      });
      $(".af-page-wrap").appendTo(
        ".workshop-form-steps-header__sidebar-navigation"
      );
      $(".workshop-form-result-btn").appendTo(
        ".workshop-form-steps-header__sidebar-controlpanel"
      );
    }, 200);
  }
}

/**
 * trigger for setting all the steps to be availalbe direclty to go to
 * @param {*} form
 */
function stepsActivator(form) {
  let n_pages = form.pages.length; // Get the total number of pages in this form.
  form.max_page = n_pages; // Set the max page to the number of pages minus 1. This is zero-indexed.
  af.pages.refresh(form); // Force a form refresh to update the UI — page links will now appear clickable.
}

/**
 *
 * @param {*} url
 */
function goToStep(url, form) {
  const params = new URLSearchParams(url, form);
  if (params.has("step")) {
    var stepParam = params.get("step");
    if ($(".af-page-button[data-index=" + '"' + stepParam + '"]')) {
      $(".af-page-button[data-index=" + '"' + stepParam + '"]').click();
    }

    $("html, body")
      .delay(2500)
      .animate(
        {
          scrollTop: form.$el.find(".acf-form-fields").offset().top - 400,
        },
        1000
      );
  }
}
